var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBagFilled = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-94 -1234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.023,20H1.632A1.638,1.638,0,0,1,0,18.359a1.722,1.722,0,0,1,.031-.326L1.253,6.809a2.244,2.244,0,0,1,2.1-2.028H14.3a2.259,2.259,0,0,1,2.11,2.028l1.218,11.224a1.646,1.646,0,0,1-1.282,1.935,1.552,1.552,0,0,1-.309.032ZM11.786,7.618a.973.973,0,1,0,.973-.985A.979.979,0,0,0,11.786,7.618Zm-7.886,0a.973.973,0,1,0,.973-.985A.979.979,0,0,0,3.9,7.618Zm9.065-2.836h-.6V4.363A3.644,3.644,0,0,0,8.835.608H8.818A3.651,3.651,0,0,0,5.3,4.386v.4H4.692v-.4A4.264,4.264,0,0,1,8.835,0,4.259,4.259,0,0,1,12.97,4.385v.4Z",
    transform: "translate(97.003 1235.997)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBagFilled, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bag-filled.0e8d37f7.svg";
export { ForwardRef as ReactComponent };